/**
 * Formats a gas-day window as a human-readable date label per the spec convention.
 *   Same month       : "April 23-24 2026"
 *   Cross-month, year: "April 30 - May 1 2026"
 *   Cross-year       : "December 31 2025 - January 1 2026"
 *
 * Inputs are YYYY-MM-DD strings (not Date objects) — these come from the
 * backend's gas_day_date column, which is a DATE type in PostgreSQL.
 */
export function formatGasDayLabel(startDateLocal: string, endDateLocal: string): string {
  const [sy, sm, sd] = startDateLocal.split('-').map(Number);
  const [ey, em, ed] = endDateLocal.split('-').map(Number);
  const monthName = (m: number) =>
    new Date(Date.UTC(2000, m - 1, 1)).toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });

  if (sy === ey && sm === em) {
    return `${monthName(sm)} ${sd}-${ed} ${sy}`;
  }
  if (sy === ey) {
    return `${monthName(sm)} ${sd} - ${monthName(em)} ${ed} ${sy}`;
  }
  return `${monthName(sm)} ${sd} ${sy} - ${monthName(em)} ${ed} ${ey}`;
}
